export default __webpack_public_path__ + "static/media/button-close.68a50a64.svg";